import * as React from 'react';
import { cn } from '@/lib/utils';
import { CardTitle } from '@/components/ui/card';

const SubjectCard = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-subject-card',
      // styles
      'relative flex cursor-auto flex-wrap gap-4 rounded-xl border border-solid border-neutral-lightest bg-white px-5 py-4 shadow-[0_4px_10px_#442b8c0d]',
      className
    )}
    {...props}
  />
));
SubjectCard.displayName = 'SubjectCard';

const SubjectCardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-subject-card-header',
      // styles
      'flex w-[236px] max-w-full grow items-center gap-3 lg:grow-0',
      className
    )}
    {...props}
  />
));
SubjectCardHeader.displayName = 'SubjectCardHeader';

const SubjectCardVideo = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-subject-card-video',
      // styles
      'h-30 relative aspect-video w-52 overflow-hidden rounded-xl bg-black',
      '[&_iframe]:absolute [&_iframe]:h-full [&_iframe]:w-full',
      className
    )}
    {...props}
  />
));
SubjectCardVideo.displayName = 'SubjectCardVideo';

const SubjectCardBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-subject-card-body',
      // styles
      'w-60 max-w-full grow',
      className
    )}
    {...props}
  />
));
SubjectCardBody.displayName = 'SubjectCardBody';

const SubjectCardBodyHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-subject-card-body-header',
      // styles
      'mb-2 flex w-full items-center gap-4',
      className
    )}
    {...props}
  />
));
SubjectCardBodyHeader.displayName = 'SubjectCardBodyHeader';

const SubjectCardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <CardTitle
    ref={ref}
    className={cn(
      'c-subject-card-title',
      // styles
      className
    )}
    {...props}
  />
));
SubjectCardTitle.displayName = 'SubjectCardTitle';

const SubjectCardTextScheduleWrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-subject-card-text-schedule-wrapper',
      // styles
      'flex flex-shrink-0 flex-col items-end gap-0.5',
      className
    )}
    {...props}
  />
));
SubjectCardTextScheduleWrapper.displayName = 'SubjectCardTextScheduleWrapper';

const SubjectCardTextSchedule = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-subject-card-text-schedule-wrapper',
      // styles
      'mb-0 inline-block w-[100px] flex-none text-right text-[10px] font-light leading-[1.2] text-[#8894AC]',
      className
    )}
    {...props}
  />
));
SubjectCardTextSchedule.displayName = 'SubjectCardTextSchedule';

export { SubjectCard, SubjectCardHeader, SubjectCardVideo, SubjectCardBody, SubjectCardBodyHeader, SubjectCardTitle, SubjectCardTextScheduleWrapper, SubjectCardTextSchedule };
